import { Icon } from '../Icon';

/** Extra match information stays out of the structure until requested. */
export function ResultMatchDetails({ text, testId }: { readonly text: string; readonly testId: string }) {
  return (
    <details
      className="result-match-details"
      onPointerEnter={(event) => {
        if (event.pointerType === 'mouse') event.currentTarget.open = true;
      }}
      onPointerLeave={(event) => {
        if (event.pointerType === 'mouse') event.currentTarget.open = false;
      }}
    >
      <summary
        aria-label={text}
        title={text}
        onKeyDown={(event) => {
          if (event.key === 'Escape') event.currentTarget.parentElement?.removeAttribute('open');
        }}
      >
        <Icon name="info" size="0.9rem" />
      </summary>
      <span className="search-result-matched-by" data-testid={testId}>
        {text}
      </span>
    </details>
  );
}
